import { baseDeilyDetailPath } from "@/router";
import Header from "./Header";
import Navigation from "./Navigation";
const BasicHeader: React.FC = () => {
  const { pathname } = useLocation();
  const headerFixNode = useRef<any>(null);
  useEffect(() => {
    sessionStorage.setItem("headerFixHeight", headerFixNode.current.scrollHeight);
  }, []);
  return (
    <div
      className="w-full mb-10"
      style={{ height: pathname.includes(baseDeilyDetailPath) ? "50px" : "100px" }}
      ref={headerFixNode}
    >
      <div className="fixed left-50% translate-x-[-50%] top-0 w-full max-w-360 flex flex-col justify-start items-start color-[#fff] z-99">
        <Header />
        <Navigation />
      </div>
    </div>
  );
};
export default BasicHeader;
